import React from "react";
import { ArtifactV1SessionPart } from "../../session.types";
import { SessionPartConfig } from "@/mds/components/sessions/session-parts/session-part.types";
import { SessionMarkdownContent } from "@/mds/components/sessions/session-parts/common/session-markdown-content";
import { OnClickMemItem } from "@mem-labs/common-editor";
import styled from "@emotion/styled";
import { MemCommonMentionKind, MemRoutableItemKind } from "@mem-labs/common-editor";

interface Props {
  artifactPart: ArtifactV1SessionPart;
  config: SessionPartConfig;
}

export const SessionArtifactDetailsRenderer: React.FC<Props> = ({ artifactPart, config }) => {
  const artifactDetails = artifactPart.artifact_details ?? [];

  const onClickHandler: OnClickMemItem = (kind, id, target, event) => {
    if (!config.linkHandler) {
      return;
    }

    let mentionKind: MemCommonMentionKind | null = null;
    switch (kind) {
      case MemRoutableItemKind.NOTES:
        mentionKind = MemCommonMentionKind.Note;
        break;
      case MemRoutableItemKind.COLLECTIONS:
        mentionKind = MemCommonMentionKind.Collection;
        break;
      case MemRoutableItemKind["TIME-RANGES"]:
        mentionKind = MemCommonMentionKind.TimeRange;
        break;
      default:
        mentionKind = null;
        break;
    }

    config.linkHandler(mentionKind, id, target, event);
  };

  return (
    <SessionDetailsWrapper>
      {artifactDetails.map(detail => (
        <SessionMarkdownContent
          key={detail.id}
          onClickMemItem={onClickHandler}
          config={config}
          content={detail.content}
        />
      ))}
    </SessionDetailsWrapper>
  );
};

const SessionDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs};
  margin-bottom: ${({ theme }) => theme.spacing.smd};
`;
